







import { Component, Vue, Prop } from 'vue-property-decorator';
import { IEpic } from '@/lib/interfaces';

@Component
export default class EpicOption extends Vue {
  @Prop() private option!: IEpic;
}
